query regenerationConditions($companyId: ID!) {
  regenerationConditions(companyId: $companyId) {
    price {
      value
      currency
    }
    included
  }
}
